module.exports = __webpack_public_path__ + "img/kyc-details-active.47d1bf68.svg";